module.exports = __webpack_public_path__ + "static/media/dan-face.583348ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/dan-face.jpg
// module id = 414
// module chunks = 0